import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ChatBot from '../components/ChatBot';
import SafeIcon from '../common/SafeIcon';
import { FiClock, FiMessageSquare, FiExternalLink } from 'react-icons/fi';

function HomePage() {
  const navigate = useNavigate();

  useEffect(() => {
    // 🛑 AGGRESSIVE WIDGET PROTECTION:
    // If the homepage (the website) loads inside an iframe or widget, 
    // force it to switch to the "Pure Chat" view immediately.
    if (window.self !== window.top) {
      console.log("Widget mode detected. Redirecting to chat...");
      navigate('/chat');
    }
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 to-orange-50 flex flex-col">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-3xl font-bold text-red-600">Rasa Sayang Asian Kitchen</h1>
              <p className="text-gray-600 mt-1">Authentic Asian Flavors • Roswell, GA</p>
            </div>
            
            {/* Direct Link to Widget for Testing */}
            <Link 
              to="/chat" 
              className="hidden md:flex items-center space-x-2 bg-orange-100 text-orange-700 px-4 py-2 rounded-lg hover:bg-orange-200 transition-colors"
            >
              <SafeIcon icon={FiMessageSquare} />
              <span>Test Chat Widget</span>
            </Link>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-grow max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 w-full">
        <div className="text-center">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Welcome to Rasa Sayang</h2>
          <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto">
            Experience the rich blend of Chinese, Thai, Malaysian, and Indonesian cuisines. 
          </p>

          <div className="flex justify-center mb-12">
             <Link 
              to="/chat" 
              className="flex items-center space-x-2 bg-[#ea580c] text-white px-6 py-3 rounded-full shadow-lg hover:bg-[#c2410c] transition-transform hover:scale-105"
            >
              <SafeIcon icon={FiMessageSquare} className="w-5 h-5" />
              <span className="font-semibold">Open Chat Widget View</span>
            </Link>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mt-8">
            <div className="bg-white rounded-lg shadow-md p-6">
              <h3 className="text-xl font-semibold text-red-600 mb-3">🍜 Authentic Cuisine</h3>
              <p className="text-gray-600">Savor traditional recipes from across Asia.</p>
            </div>
            <div className="bg-white rounded-lg shadow-md p-6">
              <h3 className="text-xl font-semibold text-red-600 mb-3">🚗 Ordering</h3>
              <p className="text-gray-600">Dine-in, takeout, and delivery available.</p>
            </div>
            <div className="bg-white rounded-lg shadow-md p-6">
              <h3 className="text-xl font-semibold text-red-600 mb-3">📍 Location</h3>
              <p className="text-gray-600">1425 Market Blvd, Roswell, GA.</p>
            </div>
          </div>
        </div>
      </main>
      
      {/* Floating Chat Button */}
      <ChatBot />
    </div>
  );
}

export default HomePage;